import { render, staticRenderFns } from "./projectManage.vue?vue&type=template&id=8d0bbd2c&scoped=true"
import script from "./projectManage.vue?vue&type=script&lang=js"
export * from "./projectManage.vue?vue&type=script&lang=js"
import style0 from "./projectManage.vue?vue&type=style&index=0&id=8d0bbd2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0bbd2c",
  null
  
)

export default component.exports